/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApproveRejectPayrollRunRequest } from '../models/ApproveRejectPayrollRunRequest';
import type { CreatePayrollRunRequest } from '../models/CreatePayrollRunRequest';
import type { Page_PayrollRunDto_ } from '../models/Page_PayrollRunDto_';
import type { Page_StaffPayrollRecordDto_ } from '../models/Page_StaffPayrollRecordDto_';
import type { PayrollRunDto } from '../models/PayrollRunDto';
import type { RegeneratePayrollRunRequest } from '../models/RegeneratePayrollRunRequest';
import type { StaffDto } from '../models/StaffDto';
import type { StaffPayrollRecordDto } from '../models/StaffPayrollRecordDto';
import type { UpdateStaffFinancialDetailRequest } from '../models/UpdateStaffFinancialDetailRequest';
import type { UpdateStaffPayrollRecordRequest } from '../models/UpdateStaffPayrollRecordRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PayrollRunControllerService {
  /**
   * getAllPayrollRuns
   * @returns Page_PayrollRunDto_ OK
   * @throws ApiError
   */
  public static getAllPayrollRunsUsingGet({
    offset,
    paged,
    pageNumber,
    pageSize,
    period,
    search,
    sortSorted,
    sortUnsorted,
    unpaged,
  }: {
    offset?: number;
    paged?: boolean;
    pageNumber?: number;
    pageSize?: number;
    /**
     * period
     */
    period?: string;
    /**
     * search
     */
    search?: string;
    sortSorted?: boolean;
    sortUnsorted?: boolean;
    unpaged?: boolean;
  }): CancelablePromise<Page_PayrollRunDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/runs',
      query: {
        offset: offset,
        paged: paged,
        pageNumber: pageNumber,
        pageSize: pageSize,
        period: period,
        search: search,
        'sort.sorted': sortSorted,
        'sort.unsorted': sortUnsorted,
        unpaged: unpaged,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * createPayrollRun
   * @returns PayrollRunDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createPayrollRunUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreatePayrollRunRequest;
  }): CancelablePromise<PayrollRunDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/runs',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * regeneratePayrollRun
   * @returns PayrollRunDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static regeneratePayrollRunUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: RegeneratePayrollRunRequest;
  }): CancelablePromise<PayrollRunDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/runs/regenerate',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateStaffFinancialDetail
   * @returns StaffDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateStaffFinancialDetailUsingPut({
    request,
    staffId,
  }: {
    /**
     * request
     */
    request: UpdateStaffFinancialDetailRequest;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<StaffDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/payroll/runs/staff/{staffId}',
      path: {
        staffId: staffId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffPayrollHistory
   * @returns Page_StaffPayrollRecordDto_ OK
   * @throws ApiError
   */
  public static getStaffPayrollHistoryUsingGet({
    staffId,
    offset,
    paged,
    pageNumber,
    pageSize,
    sortSorted,
    sortUnsorted,
    unpaged,
  }: {
    /**
     * staffId
     */
    staffId: string;
    offset?: number;
    paged?: boolean;
    pageNumber?: number;
    pageSize?: number;
    sortSorted?: boolean;
    sortUnsorted?: boolean;
    unpaged?: boolean;
  }): CancelablePromise<Page_StaffPayrollRecordDto_> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/runs/staff/{staffId}/history',
      path: {
        staffId: staffId,
      },
      query: {
        offset: offset,
        paged: paged,
        pageNumber: pageNumber,
        pageSize: pageSize,
        'sort.sorted': sortSorted,
        'sort.unsorted': sortUnsorted,
        unpaged: unpaged,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getPayrollRun
   * @returns PayrollRunDto OK
   * @throws ApiError
   */
  public static getPayrollRunUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollRunDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/runs/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deletePayrollRun
   * @returns any OK
   * @throws ApiError
   */
  public static deletePayrollRunUsingDelete({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payroll/runs/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * approvePayrollRun
   * @returns PayrollRunDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static approvePayrollRunUsingPost({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollRunDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/runs/{id}/approve',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * rejectPayrollRun
   * @returns PayrollRunDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static rejectPayrollRunUsingPost({
    id,
    request,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: ApproveRejectPayrollRunRequest;
  }): CancelablePromise<PayrollRunDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/runs/{id}/reject',
      path: {
        id: id,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffRecords
   * @returns StaffPayrollRecordDto OK
   * @throws ApiError
   */
  public static getStaffRecordsUsingGet({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<Array<StaffPayrollRecordDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/runs/{id}/staff',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getStaffRecord
   * @returns StaffPayrollRecordDto OK
   * @throws ApiError
   */
  public static getStaffRecordUsingGet({
    id,
    staffId,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<StaffPayrollRecordDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/payroll/runs/{id}/staff/{staffId}',
      path: {
        id: id,
        staffId: staffId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateStaffPayrollRecord
   * @returns StaffPayrollRecordDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static updateStaffPayrollRecordUsingPut({
    id,
    request,
    staffId,
  }: {
    /**
     * id
     */
    id: string;
    /**
     * request
     */
    request: UpdateStaffPayrollRecordRequest;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<StaffPayrollRecordDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/payroll/runs/{id}/staff/{staffId}',
      path: {
        id: id,
        staffId: staffId,
      },
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * submitForApproval
   * @returns PayrollRunDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static submitForApprovalUsingPost({
    id,
  }: {
    /**
     * id
     */
    id: string;
  }): CancelablePromise<PayrollRunDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/payroll/runs/{id}/submit',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteStaffPayrollItemEntry
   * @returns any OK
   * @throws ApiError
   */
  public static deleteStaffPayrollItemEntryUsingDelete({
    payrollItemId,
    payrollRunId,
    staffId,
  }: {
    /**
     * payrollItemId
     */
    payrollItemId: string;
    /**
     * payrollRunId
     */
    payrollRunId: string;
    /**
     * staffId
     */
    staffId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/payroll/runs/{payrollRunId}/staff/{staffId}/items/{payrollItemId}',
      path: {
        payrollItemId: payrollItemId,
        payrollRunId: payrollRunId,
        staffId: staffId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
